import { isVue3 } from 'vue-demi';
import Component3 from './component3-composition.js';
import Component2 from './component2.js';
import './props.js';
import './composable.js';
import 'imask/esm/imask';
import './utils.js';

var component = isVue3 ? Component3 : Component2;

export { component as default };
